"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringValidator = void 0;
const Validator_1 = require("./Validator");
const ERRORS = {
    IS_STRING: 'IS_STRING',
    MAX_LENGTH: 'MAX_LENGTH',
    MIN_LENGTH: 'MIN_LENGTH',
    NOT_EMPTY: 'NOT_EMPTY',
    REGEX: 'REGEX',
};
class StringValidator extends Validator_1.Validator {
    static isString(value) {
        return typeof value === 'string';
    }
    static isNotEmpty(value) {
        return !!value && value.length > 0;
    }
    static isMaxLength(value, max) {
        return _a.isNotEmpty(value) && value.length <= max;
    }
    static isMinLength(value, min) {
        return _a.isString(value) && _a.isNotEmpty(value) && value.length >= min;
    }
    static validateRegex(value, regex) {
        return regex.test(value);
    }
}
exports.StringValidator = StringValidator;
_a = StringValidator;
StringValidator.IS_STRING = () => _a.validatorFactory(_a.isString, ERRORS.IS_STRING);
StringValidator.MAX_LENGTH = (max) => _a.validatorFactory(value => _a.isMaxLength(value, max), ERRORS.MAX_LENGTH);
StringValidator.MIN_LENGTH = (min) => _a.validatorFactory(value => _a.isMinLength(value, min), ERRORS.MIN_LENGTH);
StringValidator.NOT_EMPTY = () => _a.validatorFactory(_a.isNotEmpty, ERRORS.NOT_EMPTY);
StringValidator.REGEX = (regex) => _a.validatorFactory(value => _a.validateRegex(value, regex), ERRORS.REGEX);
//# sourceMappingURL=StringValidator.js.map